<template>
    <div class="container"  :class="{ 'dark-mode': isDarkMode }">
        <div class="intro" data-aos="fade-down" data-aos-easing="ease-in-out" data-aos-duration="800"
            data-aos-anchor-placement="top">
            <p class="section_p1">Browse My Recent</p>
            <h1 class="title">Projects</h1>
        </div>

        <!-- <div class="summary">
          <div class="details">
            <h2 class="experience-title">Service Details</h2>
            <div class="collections">
              <div class="collection-details" v-for="(collection, index) in collectionData" :key="index">
                <div class="tag">
                  <i :class="collection.icon"></i>
                  <h3>{{ collection.title }}</h3>
                </div>
                <span></span>
                <p>{{ collection.count }}</p>
              </div>
            </div>
          </div>
        </div> -->

        <div class="project-details">
            <!-- <div class="mini-container"> -->
            <div class="info-container" v-for="(project, index) in projectsData" :key="index" data-aos="flip-up"
                data-aos-easing="ease-in-out" data-aos-duration="900">
                <div class="project-image">
                    <img :src="require(`@/assets/${project.image}`)" alt="Skill Image" />
                </div>

                <div class="project-info">
                    <h2>{{ project.title }}</h2>
                    <p>{{ project.description }}</p>
                    <a :href="project.website" target="_blank" class="btn">{{ project.button }}</a>
                </div>
            </div>

            <!-- <div> -->
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
    name: 'ProjectsCategory',
    data() {
        return {
            projectsData: [
                { title: "Pontus Technology", description: "Pontus Technology Limited is a leading renewable Energy Solution providers, Security Gadgets designers and maintenance company. We sale, install and service solar, inverter battery regeneration.", image: "pontus_logo.png", button: "Visit Website", website: "https://pontustechnology.com/" },
                { title: "Performance Predictor", description: "Predicting grade of students basic subjects based on analysis and data collecions, using Machine Learning.", image: "classification-vis.png", button: "Visit GitHub Repo", website: "https://github.com/David-Hunt327/Student-Performance-Prediction-System" },
                { title: "Vensemart ", description: "Vensemart connects you with experienced professionals to serve you, and provides an e-commerce platform selling only quality everyday products, which can be delivered to your doorstep any day anytime.", image: "vensmart.png", button: "Visit Website", website: "https://vensemart.com/" },
            ],
        }
    },
    computed: {
        ...mapState(['isDarkMode'])
    }
}
</script>

<style lang="scss" scoped>
.container {
    padding-top: 4vh;
    width: 100%;
    min-height: 100vh;
    height: 100%;
    // border: 1px solid green;

    // ------------------  COUNT Cat------------------- //
    // .summary {
    //     display: flex;
    //     justify-content: center;
    //     height: 100%;
    //     margin: auto 0;
    //     gap: 4rem;
    //     // border: 1px solid blue;
    //     position: relative;
    //     flex: 1;
    //     text-align: center;
    //     background: rgba(255, 255, 255, 0.164);
    //     backdrop-filter: blur(9px);
    //     border-radius: 2rem;
    //     font-size: 1rem;
    //     letter-spacing: 1px;
    //     transition: .7s;
    //     overflow: hidden;
    //     z-index: 1;
    //     padding: 1.5rem;

    //     &::before {
    //         content: "";
    //         position: absolute;
    //         top: 0;
    //         left: 0;
    //         background: white;
    //         width: 0;
    //         height: 100%;
    //         z-index: -1;
    //         transition: .4s;
    //     }

    //     &:hover::before {
    //         width: 100%;
    //     }

    //     &:hover {

    //         p,
    //         h2,
    //         h3,
    //         i {
    //             color: black;
    //         }

    //         span {
    //             background: rgb(80, 80, 80) !important;
    //         }

    //         box-shadow: 0 0 10px rgba(255, 255, 255, 1),
    //         0 0 20px rgba(255, 255, 255, 0.8),
    //         0 0 30px rgba(255, 255, 255, 0.6),
    //         0 0 40px rgba(255, 255, 255, 0.4);
    //     }

    //     .details {
    //         display: flex;
    //         justify-content: center;
    //         flex-direction: column;
    //         margin: 0 2.5rem;


    //         h2 {
    //             font-weight: 600;
    //             font-size: 1.75rem;
    //             margin-bottom: 2rem;
    //         }

    //         .collections {
    //             display: flex;
    //             flex-wrap: wrap;
    //             flex-direction: row;
    //             gap: 2rem;
    //             justify-content: space-around;
    //             width: 100%;

    //             .collection-details {
    //                 display: flex;
    //                 flex-direction: column;
    //                 justify-content: space-around;

    //                 .tag {
    //                     display: inline-flex;
    //                     align-items: center;
    //                     gap: 0.9rem;
    //                     font-size: 1.1rem;

    //                     i {
    //                         cursor: default;
    //                     }
    //                 }

    //                 span {
    //                     width: 100%;
    //                     height: .3rem;
    //                     background: white;
    //                     border-radius: 5px;
    //                     margin: 1.3rem 0;
    //                 }

    //                 p {
    //                     font-size: 1.3rem;
    //                     font-weight: 600;
    //                 }
    //             }
    //         }
    //     }
    // }

    // ------------------  DISPLAY Cat------------------- //
    .project-details {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        gap: 2rem;
        padding: 5% 0;



        .info-container {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            background: rgba(255, 255, 255, 0.164);
            backdrop-filter: blur(9px);
            max-width: 400px;
            min-height: 0;
            border-radius: 10px;
            flex: 1 1 auto;
            overflow: hidden;
            transition: box-shadow 0.6s ease-in-out;
            box-sizing: border-box;


            &:hover {
                box-shadow: 0 0 10px rgba(13, 0, 0, 1),
                0px 0px 21px rgba(13, 0, 0, 0.078),
                0px 0px 24px rgba(13, 0, 0, 0.082),
                0px 1px 4px rgba(13, 0, 0, 0.016);

                @media(max-width: 750px) {
                    box-shadow: 0 0 5px rgba(13, 0, 0, 1),
                    0px 0px 25px rgba(13, 0, 0, 0.6);
                }
            }

            .project-image {
                flex: 2;
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                overflow: hidden;
                padding: 1rem;

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    transition: transform 0.7s ease-in-out;

                    &:hover {
                        transform: scale(1.1);
                    }
                }
            }

            .project-info {
                flex: 1;
                width: 100%;
                display: flex;
                flex-direction: column;
                transition: 0.5s;
                padding: 1.5rem;
                background: rgba(128, 128, 128, 0.61);

                h2 {
                    font-size: 1.5rem;
                    font-weight: 600;
                    color: black;
                    padding-bottom: 1.5rem;
                }

                p {
                    font-size: .9rem;
                    font-weight: 500;
                    margin-bottom: 2rem;
                    color: white;
                }

                a {
                    position: relative;
                    display: inline-flex;
                    justify-content: center;
                    align-items: center;
                    padding: 1.2rem .9rem;
                    background: rgba(255, 255, 255, 0.322);
                    backdrop-filter: blur(8px);
                    color: black;
                    font-size: 1rem;
                    letter-spacing: 1px;
                    font-weight: 600;
                    transition: .6s;
                    border-radius: 10px;
                    overflow: hidden;
                    z-index: 1;
                    border: 2px solid white;

                    &::before {
                        content: "";
                        position: absolute;
                        top: 0;
                        left: 0;
                        background: black;
                        width: 0;
                        height: 100%;
                        z-index: -1;
                        transition: .3s;

                    }

                    &:hover::before {
                        width: 100%;
                    }

                    &:hover {
                        box-shadow: 0 0 10px rgba(255, 255, 255, 1),
                        0 0 21px rgba(255, 255, 255, 0.8),
                        0 0 24px rgba(255, 255, 255, 0.6),
                        0 0 4px rgba(255, 255, 255, 0.4);

                        @media(max-width: 750px) {
                            box-shadow: 0 0 8px rgba(255, 255, 255, 1),
                            0 0 25px rgba(255, 255, 255, 0.6);
                        }
                        color: white;
                    }
                }
            }
        }
    }
}

.dark-mode {
    .project-details {
        .info-container {

            background: rgba(255, 255, 255, 0.164);
            backdrop-filter: blur(9px);

            &:hover {
                box-shadow: 0 0 10px rgba(255, 255, 255, 1),
                0 0 21px rgba(255, 255, 255, 0.8),
                0 0 24px rgba(255, 255, 255, 0.6),
                0 0 4px rgba(255, 255, 255, 0.4);

                @media(max-width: 750px) {
                    box-shadow: 0 0 8px rgba(255, 255, 255, 1),
                    0 0 25px rgba(255, 255, 255, 0.6);
                }
            }

            .project-info {
                background: rgba(128, 128, 128, 0.61);

                a {
                    background: rgba(255, 255, 255, 0.322);
                    backdrop-filter: blur(8px);
                    color: white;
                    border: 2px solid white;

                    &::before {
                        background: white;
                    }

                    &:hover::before {
                        width: 100%;
                    }

                    &:hover {
                        box-shadow: 0 0 10px rgba(255, 255, 255, 1),
                        0 0 21px rgba(255, 255, 255, 0.8),
                        0 0 24px rgba(255, 255, 255, 0.6),
                        0 0 4px rgba(255, 255, 255, 0.4);

                        @media(max-width: 750px) {
                            box-shadow: 0 0 8px rgba(255, 255, 255, 1),
                            0 0 25px rgba(255, 255, 255, 0.6);
                        }
                        color: black;
                    }
                }
            }
        }
    }
}
</style>